module.exports = __webpack_public_path__ + "resources/icon-star-orange.a30d21a306729c70.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/avatar/img/icon-star-orange.png
// module id = 411
// module chunks = 0 1 2 3 4